export const headersObjectArray = object => {
  const headersArray = Object.entries(object);

  return headersArray.map(([key, value]) => ({
    name: key,
    result: value,
  }));
};
